module.exports = __webpack_public_path__ + "img/proximasoft-bold-webfont.f6d0329.svg";